import avatar2Png from '@listening/assets/astro/images/avatar2.png';
import avatar3Webp from '@listening/assets/astro/images/avatar3.webp';
import frame1362789785Png from '@listening/assets/astro/images/Frame-1362789785.png';
import frame13627897851Png from '@listening/assets/astro/images/Frame-1362789785_1.png';
import frame13627897851Png_ from '@listening/assets/astro/images/Frame-1362789785-1.png';
import frame136278978521Png from '@listening/assets/astro/images/Frame-1362789785-2_1.png';
import frame136278978531Png from '@listening/assets/astro/images/Frame-1362789785-3_1.png';
import frame13627897854Png from '@listening/assets/astro/images/Frame-1362789785-4.png';
import frame136278978541Png from '@listening/assets/astro/images/Frame-1362789785-4_1.png';
import frame13627897855Png from '@listening/assets/astro/images/Frame-1362789785-5.png';
import frame13627897856Png from '@listening/assets/astro/images/Frame-1362789785-6.png';
import frame13627897857Png from '@listening/assets/astro/images/Frame-1362789785-7.png';
import frame13627897858Png from '@listening/assets/astro/images/Frame-1362789785-8.png';
import frame1362789821Png from '@listening/assets/astro/images/Frame-1362789821.png';
import frame1362789822Png from '@listening/assets/astro/images/Frame-1362789822.png';
import frame1362789823Png from '@listening/assets/astro/images/Frame-1362789823.png';
import frame1362789824Png from '@listening/assets/astro/images/Frame-1362789824.png';
import frame1362789825Png from '@listening/assets/astro/images/Frame-1362789825.png';
import frame1362789826Png from '@listening/assets/astro/images/Frame-1362789826.png';
import frame1362789827Png from '@listening/assets/astro/images/Frame-1362789827.png';
import logoSmallSvg from '@listening/assets/astro/images/listening-logo-small.svg';
import starSvg from '@listening/assets/astro/images/star.svg';

function UserAvatarImage({ src }: { src: string }) {
  return (
    <img alt='User avatar' className='mx-[-6px]' loading='lazy' src={src} />
  );
}

export function WhatDoPeopleThinkSection() {
  return (
    <section className='relative flex flex-col items-stretch px-0 pt-20 pb-18'>
      <div className='pointer-events-none absolute top-0 left-1/2 z-10 -translate-x-1/2 select-none'>
        <div className='rounded-full bg-white p-[20px]'>
          <div className='flex size-18 items-center justify-center rounded-full bg-white [box-shadow:0_0_19px_3px_rgba(0,_0,_0,_.2)] lg:size-[100px]'>
            <img
              alt='Listening logo'
              className='w-[40px]'
              loading='lazy'
              src={logoSmallSvg}
            />
          </div>
        </div>
      </div>
      <div
        className='relative flex min-h-[1650px] flex-col items-center gap-14 bg-[linear-gradient(rgba(16,_68,_255,_.1),_#fff)] px-5 sm:min-h-[1800px] sm:px-18 md:min-h-[1500px] lg:min-h-[1600px]'
        id='customers'
      >
        <div className='mb-3 grid h-12 grid-cols-2 items-center gap-6 select-none sm:h-14'>
          <div className='mx-2 h-full w-full rounded-full bg-mist-550 sm:mx-4' />
          <div className='mx-2 h-full w-full rounded-full bg-mist-550 sm:mx-4' />
        </div>
        <div className='flex flex-col items-center gap-[34px] pt-2'>
          <h2 className='text-center text-[32px] leading-[34px] font-[700] text-neutral-945 sm:text-[40px] sm:leading-[43px] lg:text-[48px] lg:leading-[48px]'>
            What people think <span className='text-azure-595'>about us</span>
          </h2>
          <div className='flex flex-col items-center gap-3'>
            <div className='flex items-center justify-center gap-0'>
              <UserAvatarImage src={frame1362789821Png} />
              <UserAvatarImage src={frame1362789822Png} />
              <UserAvatarImage src={frame1362789823Png} />
              <UserAvatarImage src={frame1362789824Png} />
              <UserAvatarImage src={frame1362789825Png} />
              <UserAvatarImage src={frame1362789826Png} />
              <UserAvatarImage src={frame1362789827Png} />
              <UserAvatarImage src={frame13627897854Png} />
            </div>
            <div className='mb-4 text-center text-[24px] text-neutral-945 lg:text-[20px] lg:leading-[24px]'>
              <span className='font-[600]'>+ more than 50k people</span> enjoy
              Listening
            </div>
          </div>
        </div>
        <div className='flex max-w-[1296px] flex-nowrap items-start justify-center gap-x-4 overflow-hidden'>
          <div className='flex flex-1 auto-cols-[minmax(306px,_1fr)] grid-flow-row-dense auto-rows-min grid-cols-[repeat(auto-fit,minmax(306px,1fr))] grid-rows-[min-content] justify-items-center gap-4 pb-18 [flex-flow:column]'>
            <div className='flex flex-col gap-4 rounded-[16px] bg-white p-[24px]'>
              <div className='flex gap-4'>
                <img
                  alt='User avatar'
                  className='size-[48px] rounded-full lg:size-[48px] lg:rounded-full'
                  loading='lazy'
                  src={frame1362789785Png}
                />
                <div className='flex flex-col justify-center'>
                  <div className='text-[20px] leading-[27px] font-[500] text-neutral-945'>
                    <strong>AlexP1799</strong>
                  </div>
                </div>
              </div>
              <div className='flex flex-col gap-4'>
                <div className='text-[18px] leading-[32px] font-[500] text-neutral-840'>
                  This app is a MUST for anyone in academics. I’ve only had it
                  for a couple of weeks and I’m already sold. I’m in grad school
                  at the moment and almost all of our reading are academic
                  articles. It takes me ages to get through them every week and
                  by the end it feels like my eyes are going to fall out of my
                  head.
                </div>
                <div className='flex lg:flex'>
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                </div>
              </div>
            </div>
            <div className='flex flex-col gap-4 rounded-[16px] bg-white p-[24px]'>
              <div className='flex gap-4'>
                <img
                  alt='User avatar'
                  className='size-[48px] rounded-full lg:size-[48px] lg:rounded-full'
                  loading='lazy'
                  src={frame13627897851Png}
                />
                <div className='flex flex-col justify-center'>
                  <div className='text-[20px] leading-[27px] font-[500] text-neutral-945'>
                    Bell Jelly
                  </div>
                </div>
              </div>
              <div className='flex flex-col gap-4'>
                <div className='text-[18px] leading-[32px] font-[500] text-neutral-840'>
                  Love using it to read papers and journal articles. The text is
                  often too dense for me and my eyes skip words, making it
                  difficult to understand what I just read. With the app, I can
                  slow down the speed of speech and listen while my visual brain
                  generates images (much easier for me to do than with reading).
                  I would suggest perhaps removing the reference numbers, it is
                  distracting while listening. Otherwise, I like where this is
                  going! Thank you!
                </div>
                <div className='flex lg:flex'>
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                </div>
              </div>
            </div>
            <div className='flex flex-col gap-4 rounded-[16px] bg-white p-[24px]'>
              <div className='flex gap-4'>
                <img
                  alt='User avatar'
                  className='size-[48px] rounded-full lg:size-[48px] lg:rounded-full'
                  loading='lazy'
                  src={frame13627897856Png}
                />
                <div className='flex flex-col justify-center'>
                  <div className='text-[20px] leading-[27px] font-[500] text-neutral-945'>
                    Samantha Lumby
                  </div>
                </div>
              </div>
              <div className='flex flex-col gap-4'>
                <div className='text-[18px] leading-[32px] font-[500] text-neutral-840'>
                  Absolutely brilliant, haven't been able to find an app that
                  can say scientific words properly until now. Very easy to use
                </div>
                <div className='flex lg:flex'>
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                </div>
              </div>
            </div>
          </div>
          <div className='hidden flex-1 auto-cols-[minmax(306px,_1fr)] grid-flow-row-dense auto-rows-min grid-cols-[repeat(auto-fit,minmax(306px,1fr))] grid-rows-[min-content] justify-items-center gap-4 pb-18 [flex-flow:column] lg:flex'>
            <div className='flex flex-col gap-4 rounded-2xl bg-white p-6'>
              <div className='flex gap-4'>
                <img
                  alt='User avatar'
                  className='size-12 rounded-full'
                  loading='lazy'
                  src={frame13627897855Png}
                />
                <div className='flex flex-col justify-center'>
                  <div className='text-[20px] leading-[27px] font-[500] text-neutral-945'>
                    Mary Ballard-Johansson
                  </div>
                </div>
              </div>
              <div className='flex flex-col gap-4'>
                <div className='text-[18px] leading-[32px] font-[500] text-neutral-840'>
                  What a great app! The reading voice is pleasant and
                  understandable. Even on the harder words. Having the text
                  available to read along helps also. Naturally, as with any new
                  app, there are bugs. But support is readily available. Highly
                  recommend this for anyone doing research or just keeping up
                  with the latest articles.
                </div>
                <div className='flex'>
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                </div>
              </div>
            </div>
            <div className='flex flex-col gap-4 rounded-[16px] bg-white p-[24px]'>
              <div className='flex gap-4'>
                <img
                  alt='User avatar'
                  className='size-[48px] rounded-full lg:size-[48px] lg:rounded-full'
                  loading='lazy'
                  src={frame136278978521Png}
                />
                <div className='flex flex-col justify-center'>
                  <div className='text-[20px] leading-[27px] font-[500] text-neutral-945'>
                    Sean Gruber
                  </div>
                </div>
              </div>
              <div className='flex flex-col gap-4'>
                <div className='text-[18px] leading-[32px] font-[500] text-neutral-840'>
                  Already thoroughly impressed! I've used Natural Reader for a
                  while, but this is cheaper, designed specifically for academic
                  papers (e.g., organizes into typical paper-sections, like
                  abstract and findings), and, in my opinion, has a more natural
                  flow in the AI voice. HIGHLY recommend!
                </div>
                <div className='flex'>
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                </div>
              </div>
            </div>
            <div className='flex flex-col gap-4 rounded-[16px] bg-white p-[24px]'>
              <div className='flex gap-4'>
                <img
                  alt='User avatar'
                  className='size-[48px] rounded-full lg:size-[48px] lg:rounded-full'
                  loading='lazy'
                  src={avatar2Png}
                />
                <div className='flex flex-col justify-center'>
                  <div className='text-[20px] leading-[27px] font-[500] text-neutral-945'>
                    Matthew Indy
                  </div>
                </div>
              </div>
              <div className='flex flex-col gap-4'>
                <div className='text-[18px] leading-[32px] font-[500] text-neutral-840'>
                  Exceptional app for curating a personal podcast of text I want
                  to 'read' as audio. <br />
                </div>
                <div className='flex'>
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                </div>
              </div>
            </div>
          </div>
          <div className='hidden flex-1 auto-cols-[minmax(306px,_1fr)] grid-flow-row-dense auto-rows-min grid-cols-[repeat(auto-fit,minmax(306px,1fr))] grid-rows-[min-content] justify-items-center gap-4 pb-18 [flex-flow:column] md:flex'>
            <div className='flex flex-col gap-4 rounded-[16px] bg-white p-[24px]'>
              <div className='flex gap-4'>
                <img
                  alt='User avatar'
                  className='size-[48px] rounded-full lg:size-[48px] lg:rounded-full'
                  loading='lazy'
                  src={frame13627897851Png_}
                />
                <div className='flex flex-col justify-center'>
                  <div className='text-[20px] leading-[27px] font-[500] text-neutral-945'>
                    Róisín Hennessy
                  </div>
                </div>
              </div>
              <div className='flex flex-col gap-4'>
                <div className='text-[18px] leading-[32px] font-[500] text-neutral-840'>
                  Brilliant app! I have dyslexia and have previously used Otter,
                  Text Help and Glean, this reader outshines all dramatically.
                  The text display is very clear while listening. The
                  pronunciation is fantastic and the app allows you to report
                  mispronunciations which happen rarely. My favorite part is
                  that you can turn off citations so the text reads smoothly and
                  you can easily skip unimportant information. The note feature
                  is an added bonus too. This app was clearly created by people
                  who care!
                </div>
                <div className='flex'>
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                </div>
              </div>
            </div>
            <div className='flex flex-col gap-4 rounded-[16px] bg-white p-[24px]'>
              <div className='flex gap-4'>
                <img
                  alt='User avatar'
                  className='size-[48px] rounded-full lg:size-[48px] lg:rounded-full'
                  loading='lazy'
                  src={frame136278978531Png}
                />
                <div className='flex flex-col justify-center'>
                  <div className='text-[20px] leading-[27px] font-[500] text-neutral-945'>
                    Watson Chiwambo
                  </div>
                </div>
              </div>
              <div className='flex flex-col gap-4'>
                <div className='text-[18px] leading-[32px] font-[500] text-neutral-840'>
                  Amazing app to help you study especially if you don't have
                  much time due to work, family and other things. <br />
                </div>
                <div className='flex'>
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                </div>
              </div>
            </div>
            <div className='flex flex-col gap-4 rounded-[16px] bg-white p-[24px]'>
              <div className='flex gap-4'>
                <img
                  alt='User avatar'
                  className='size-[48px] rounded-full lg:size-[48px] lg:rounded-full'
                  loading='lazy'
                  src={frame136278978541Png}
                />
                <div className='flex flex-col justify-center'>
                  <div className='text-[20px] leading-[27px] font-[500] text-neutral-945'>
                    Eric Allam
                  </div>
                </div>
              </div>
              <div className='flex flex-col gap-4'>
                <div className='text-[18px] leading-[32px] font-[500] text-neutral-840'>
                  Love this for listening to stuff I would never get around to
                  reading while on my morning commute. Definitely saves me lots
                  of time
                </div>
                <div className='flex'>
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                </div>
              </div>
            </div>
          </div>
          <div className='hidden flex-1 auto-cols-[minmax(306px,_1fr)] grid-flow-row-dense auto-rows-min grid-cols-[repeat(auto-fit,minmax(306px,1fr))] grid-rows-[min-content] justify-items-center gap-4 pb-18 [flex-flow:column] lg:flex'>
            <div className='flex flex-col gap-4 rounded-[16px] bg-white p-[24px]'>
              <div className='flex gap-4'>
                <img
                  alt='User avatar'
                  className='size-[48px] rounded-full lg:size-[48px] lg:rounded-full'
                  loading='lazy'
                  src={frame13627897858Png}
                />
                <div className='flex flex-col justify-center'>
                  <div className='text-[20px] leading-[27px] font-[500] text-neutral-945'>
                    Lauren Fratamico
                  </div>
                </div>
              </div>
              <div className='flex flex-col gap-4'>
                <div className='text-[18px] leading-[32px] font-[500] text-neutral-840'>
                  I always have stacks of papers I want to get through, and it's
                  been so nice to finally find an app that allows me to listen
                  to them on the go with a naturalistic voice. Would recommend!
                </div>
                <div className='flex'>
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                </div>
              </div>
            </div>
            <div className='flex flex-col gap-4 rounded-[16px] bg-white p-[24px]'>
              <div className='flex gap-4'>
                <img
                  alt='User avatar'
                  className='size-[48px] rounded-full lg:size-[48px] lg:rounded-full'
                  loading='lazy'
                  src={frame13627897857Png}
                />
                <div className='flex flex-col justify-center'>
                  <div className='text-[20px] leading-[27px] font-[500] text-neutral-945'>
                    Erin Barnes
                  </div>
                </div>
              </div>
              <div className='flex flex-col gap-4'>
                <div className='text-[18px] leading-[32px] font-[500] text-neutral-840'>
                  The app is impressive. easy to listening to, no robotic voice,
                  easy to use. productive use of my driving time. would
                  recommend.
                </div>
                <div className='flex'>
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                </div>
              </div>
            </div>
            <div className='flex flex-col gap-4 rounded-[16px] bg-white p-[24px]'>
              <div className='flex gap-4'>
                <img
                  alt='User avatar'
                  className='size-[48px] rounded-full lg:size-[48px] lg:rounded-full'
                  loading='lazy'
                  src={avatar3Webp}
                />
                <div className='flex flex-col justify-center'>
                  <div className='text-[20px] leading-[27px] font-[500] text-neutral-945'>
                    Tim Osterbuhr
                  </div>
                </div>
              </div>
              <div className='flex flex-col gap-4'>
                <div className='text-[18px] leading-[32px] font-[500] text-neutral-840'>
                  Great way to listen to papers during my commute. Finally a
                  voice that doesn't sound like a robot. <br />
                </div>
                <div className='flex'>
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                </div>
              </div>
            </div>
            <div className='flex flex-col gap-4 rounded-[16px] bg-white p-[24px]'>
              <div className='flex gap-4'>
                <img
                  alt='User avatar'
                  className='size-[48px] rounded-full lg:size-[48px] lg:rounded-full'
                  loading='lazy'
                  src={frame13627897854Png}
                />
                <div className='flex flex-col justify-center'>
                  <div className='text-[20px] leading-[27px] font-[500] text-neutral-945'>
                    Nathalie Tasler
                  </div>
                </div>
              </div>
              <div className='flex flex-col gap-4'>
                <div className='text-[18px] leading-[32px] font-[500] text-neutral-840'>
                  Having to get through academic texts it is great to have an
                  app that doesn't force you to listen to the same header and
                  footer at every single page!!! the listening experience is
                  also comfortable more natural sounding than other apps I tried
                  before.
                  <br />
                </div>
                <div className='flex'>
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                  <img alt='Rating star' loading='lazy' src={starSvg} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='absolute bottom-0 h-[120px] w-full bg-[linear-gradient(to_top,_#fff,_rgba(255,_255,_255,_0))] lg:h-[100px]' />
      </div>
    </section>
  );
}
